import { useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { ExitToApp as ExitToAppIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { UserContext } from "@/contexts/user";

const LogoutBtn = () => {
  // @ts-ignore
  const [, dispatch] = useContext(UserContext);
  const { oktaAuth } = useOktaAuth();
  const { t } = useTranslation();

  const handleDisconnect = async () => {
    dispatch({ type: "REMOVE_USER" });
    await oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + "/login",
    });
  };

  return (
    <ListItem button onClick={handleDisconnect}>
      <ListItemIcon>
        <ExitToAppIcon color="secondary" />
      </ListItemIcon>
      <ListItemText
        disableTypography
        primary={
          <Typography
            variant="body1"
            style={{
              fontSize: 14,
            }}
          >
            {t("dashboard.menu.logout")}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default LogoutBtn;
